import { previewServiceFactory } from './PreviewServiceFactory';

import type { ExportOption, PreviewConfig } from '../types';
import type { PreviewGenerationContext } from './PreviewService.types';

type GetPreviewContentParams = {
  previewConfig: PreviewConfig | undefined;
  exportOption: ExportOption;
  fileContent: string | undefined;
  exportApiRequestString: string;
  context: PreviewGenerationContext;
};

export const getPreviewContent = ({
  previewConfig,
  exportOption,
  fileContent,
  exportApiRequestString,
  context
}: GetPreviewContentParams): string => {
  if (!previewConfig) return '';

  // Code and simple previews may fetch a template file
  if (
    (previewConfig.type === 'code' || previewConfig.type === 'simple') &&
    previewConfig.fetchTemplate &&
    fileContent
  ) {
    return fileContent;
  }

  switch (previewConfig.type) {
    case 'api':
      return exportApiRequestString;
    case 'code': {
      if (exportOption.id === 'curl') {
        return previewServiceFactory.getAPIService().generateCurlCommand(context);
      }
      return fileContent ?? '';
    }
    case 'sql':
      return previewServiceFactory.getSnowflakeService().generatePreview(context).content;
    case 'simple':
      return fileContent ?? '';
    default:
      return fileContent ?? '';
  }
};
